import { render, staticRenderFns } from "./DataImportLogsForm.vue?vue&type=template&id=05342c9e&scoped=true"
import script from "./DataImportLogsForm.vue?vue&type=script&lang=js"
export * from "./DataImportLogsForm.vue?vue&type=script&lang=js"
import style0 from "./DataImportLogsForm.vue?vue&type=style&index=0&id=05342c9e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05342c9e",
  null
  
)

export default component.exports